'use es6';

import Url from 'urlinator/Url';
import http from 'hub-http/clients/noAuthApiClient';
import BaseLoginDao from './BaseLoginDao';
const URL_LOADED_LOCAL = Url.loaded.local;

class GoogleLoginDao extends BaseLoginDao {
  initialize(credentials) {
    credentials.redirectToLocal = URL_LOADED_LOCAL;
    return this.loginAtPath('/login-api/v1/google/init', credentials, 'app');
  }

  passCredentialResponse(response) {
    return http.post('/login-api/v1/google/one-tap', {
      data: response
    });
  }

}

export default GoogleLoginDao;